import {
  IconAnalytics,
  IconBell,
  IconBellGray,
  IconBinocularsGray,
  IconChainLink,
  IconChainLinkGray,
  IconChartBar,
  IconChartBarGray,
  IconChartRadius,
  IconClockGray,
  IconCloudCheckGray,
  IconDashboard,
  IconLayers,
  IconLocation,
  IconPenSquare,
  IconRoute,
  IconRulerGray,
  IconSearch,
  IconSecurity,
  IconShareGray,
  IconTagGray,
  IconTvocGray,
  IconWarning,
  IconZoneGray,
} from '@assets/images/icon';
import { rtlsSystem } from '@assets/images/solution';
import video from '@src/assets/images/solution/retailOffice/video/rtlsVideo.mp4';

import subVideo1 from '@src/assets/images/solution/retailOffice/video/sub/rtlsVideo1.mp4';
import subVideo2 from '@src/assets/images/solution/retailOffice/video/sub/rtlsVideo2.mp4';
import subVideo3 from '@src/assets/images/solution/retailOffice/video/sub/rtlsVideo3.mp4';

import image1 from '@src/assets/images/solution/retailMobile/img/1.avif';
import image2 from '@src/assets/images/solution/retailMobile/img/2.avif';
import image3 from '@src/assets/images/solution/retailMobile/img/3.avif';
import image4 from '@src/assets/images/solution/retailMobile/img/4.avif';
import image5 from '@src/assets/images/solution/retailMobile/img/5.avif';
import image6 from '@src/assets/images/solution/retailMobile/img/6.avif';
import image7 from '@src/assets/images/solution/retailMobile/img/7.avif';
import image8 from '@src/assets/images/solution/retailMobile/img/8.avif';
import { recommendationEdge, recommendationSwitch, retailMobile1, retailMobile2 } from '@assets/images/solution/recommendation';
import recommendation from '../common/recommendation';

export default {
  type: 'Giải pháp bán lẻ',
  banner: {
    title: 'Trải nghiệm điện thoại tự do, quản lý an ninh trưng bày tự động',
    desc: 'Cung cấp trải nghiệm điện thoại tự do nhờ công nghệ thẻ không dây và tự động duy trì an ninh trưng bày.',
  },

  recommend: {
    title: '',
    desc: 'ORBRO OS là nền tảng mạnh mẽ cho theo dõi vị trí thời gian thực và giám sát thông minh.<br/>Tích hợp hoàn hảo công nghệ BLE, UWB và phân tích hình ảnh dựa trên AI, giúp đảm bảo an toàn, hiệu quả và khả năng mở rộng trong môi trường công nghiệp.',
    labels: {
      desktop: [
        { img: retailMobile1, data: recommendation.safeTag },
        { img: retailMobile2, data: recommendation.safeCradle },
        { img: recommendationEdge, data: recommendation.edgeRtls },
        { img: recommendationSwitch, data: recommendation.switch },
      ],
      mobile: [{ data: recommendation.safeTag }, { data: recommendation.safeCradle }, { data: recommendation.edgeRtls }, { data: recommendation.switch }],
    },
  },

  func: [
    {
      theme: 'Xây dựng môi trường trưng bày thông minh theo hành trình trải nghiệm khách hàng',
      title: 'Cửa hàng điện thoại di động với trải nghiệm tự do',
      desc: 'Khách hàng có thể tự do cầm và sử dụng điện thoại để trải nghiệm thực tế. Thiết kế không dây giúp duy trì an ninh mà không giới hạn người dùng.',
      sub1: 'Theo dõi vị trí thời gian thực',
      icon1: IconBinocularsGray,
      sub2: 'Độ chính xác cao',
      icon2: IconRulerGray,
      image: image1,
    },
    {
      title: 'Hiển thị thông tin đồng bộ với màn hình số',
      desc: 'Khi nhấc thiết bị lên, thông tin sản phẩm sẽ tự động hiển thị trên màn hình số, giúp khách hàng dễ dàng nắm bắt mà không cần hướng dẫn.',
      sub1: 'Nắm bắt tình trạng thời gian thực',
      icon1: IconClockGray,
      sub2: 'Liên kết dữ liệu nhanh chóng',
      icon2: IconShareGray,
      image: image2,
    },
    {
      title: 'Cảnh báo rời khỏi vị trí & thông báo cho quản lý',
      desc: 'Khi thiết bị vượt ra khỏi vị trí quy định, thẻ sẽ phát cảnh báo và gửi thông báo đến quản lý, giúp xử lý kịp thời mà không cản trở trải nghiệm người dùng.',
      sub1: 'Cung cấp dữ liệu thống kê',
      icon1: IconChartBarGray,
      sub2: 'Lưu trữ dữ liệu trên đám mây',
      icon2: IconCloudCheckGray,
      image: image3,
    },
    {
      title: 'Phân tích thiết bị được yêu thích dựa trên dữ liệu trải nghiệm',
      desc: 'Số lần nhấc thiết bị và sử dụng chức năng so sánh được lưu tự động, phục vụ cho phân tích xu hướng sử dụng và tối ưu bố trí sản phẩm.',
      sub1: 'Cung cấp dữ liệu thống kê',
      icon1: IconChartBarGray,
      sub2: 'Lưu trữ dữ liệu trên đám mây',
      icon2: IconCloudCheckGray,
      image: image4,
    },
    {
      theme: 'Giới thiệu thẻ và đế chuyên dụng cho trưng bày thiết bị',
      title: 'Thẻ không dây cho trải nghiệm tự do',
      desc: 'Safe Tag gắn vào thiết bị để cấp nguồn và theo dõi vị trí. Bảo mật vẫn được duy trì mà không cần dây cáp, giúp khách hàng thoải mái trải nghiệm.',
      sub1: 'Cung cấp dữ liệu thống kê',
      icon1: IconChartBarGray,
      sub2: 'Lưu trữ dữ liệu trên đám mây',
      icon2: IconCloudCheckGray,
      image: image5,
    },
    {
      title: 'Thiết kế tương thích với mọi dòng điện thoại',
      desc: 'Safe Tag có thể dán lên hầu hết các loại điện thoại, bất kể hãng sản xuất hay dòng máy, giúp quản lý đồng bộ và linh hoạt.',
      sub1: 'Cung cấp dữ liệu thống kê',
      icon1: IconChartBarGray,
      sub2: 'Lưu trữ dữ liệu trên đám mây',
      icon2: IconCloudCheckGray,
      image: image6,
    },
    {
      title: 'Đế trưng bày tích hợp bảo mật',
      desc: 'Đế được thiết kế để cấp nguồn ổn định và theo dõi vị trí thiết bị theo thời gian thực. Vừa hỗ trợ sạc không dây, vừa giới hạn phạm vi di chuyển để đảm bảo an toàn.',
      sub1: 'Cung cấp dữ liệu thống kê',
      icon1: IconChartBarGray,
      sub2: 'Lưu trữ dữ liệu trên đám mây',
      icon2: IconCloudCheckGray,
      image: image7,
    },
    {
      title: 'Thiết kế góc đế 15° tối ưu cho trải nghiệm',
      desc: 'Đế được thiết kế với góc nghiêng 15 độ giúp việc cầm và đặt thiết bị trở nên tự nhiên, duy trì sự ổn định trong trải nghiệm lặp lại.',
      sub1: 'Cung cấp dữ liệu thống kê',
      icon1: IconChartBarGray,
      sub2: 'Lưu trữ dữ liệu trên đám mây',
      icon2: IconCloudCheckGray,
      image: image8,
    },
  ],

  subfunc: {
    title: 'Tổng quan chức năng',
    desc: 'Giúp quản lý kho hiệu quả, tiết kiệm chi phí và thời gian, đảm bảo minh bạch và dễ dàng truy xuất.<br/>Để tạo ra môi trường làm việc tối ưu và hiệu quả cao nhất, ORBRO cung cấp thêm các chức năng sau.',
    data: [
      {
        icon: IconLayers,
        title: 'Cấu trúc trưng bày dùng thẻ không dây',
        desc: 'Gắn thẻ lên thiết bị trưng bày để theo dõi vị trí và trạng thái không dây.',
      },
      {
        icon: IconLocation,
        title: 'Bảo mật dựa trên phát hiện khoảng cách',
        desc: 'Phát hiện khi thiết bị vượt khỏi khoảng cách cho phép và kích hoạt cảnh báo.',
      },
      {
        icon: IconSearch,
        title: 'Thiết kế gắn thẻ gọn gàng tích hợp',
        desc: 'Thẻ được dán gọn dưới đáy thiết bị, giữ vẻ thẩm mỹ cho sản phẩm trưng bày.',
      },
      {
        icon: IconAnalytics,
        title: 'Thông báo khi phát hiện thiết bị rời khỏi vị trí',
        desc: 'Khi thiết bị rời khỏi vị trí định sẵn, thẻ sẽ phát tín hiệu cảnh báo và gửi thông báo đến người quản lý.',
      },
      {
        icon: IconChartBar,
        title: 'Theo dõi vị trí & cấp nguồn thời gian thực',
        desc: 'Thiết bị được cấp nguồn và theo dõi liên tục ngay trong khi trưng bày.',
      },
      {
        icon: IconRoute,
        title: 'Cấu trúc bản lề trượt',
        desc: 'Thẻ có thể điều chỉnh linh hoạt theo vị trí cổng sạc, phù hợp với nhiều thiết bị.',
      },
      {
        icon: IconRoute,
        title: 'Thiết kế góc gắn 15 độ',
        desc: 'Tạo cảm giác tự nhiên khi nhấc và đặt lại thiết bị, tối ưu trải nghiệm người dùng.',
      },
      {
        icon: IconLayers,
        title: 'Môi trường trưng bày không dây',
        desc: 'Thẻ và đế ẩn bên trong, giữ cho không gian trưng bày gọn gàng và cấp nguồn ổn định.',
      },
    ],
  },

  system: {
    title: 'Cấu hình hệ thống',
    img: rtlsSystem,
  },

  productTitle: 'Cấu trúc sản phẩm',
  product: [{ tag: 'assetPackage' }, { tag: 'workerPackage' }],

  contents: [{ data: 'logisticsAsset' }, { data: 'manufacturingSteel' }, { data: 'blogOffice' }, { data: 'blogRTLS' }],
};
